import { AssessmentClass } from "../fithub-shared/anthropometry/assessment";

import Chart from "react-apexcharts";
import { FaChartPie } from "react-icons/fa";
// import { Container } from './styles';

const ComparisionGraph = ({ data }: { data: AssessmentClass[] }) => {
  const renderGraphSection = () => {
    const colors = ["#EF4444", "#10B981", "#3B82F6", "#F59E0B"]; // fat, muscles, wastes, bones

    if (!data || data.length === 0) {
      return (
        <div className="mb-8 flex-col">
          <h3 className="mb-2 text-lg font-semibold text-zinc-700 dark:text-zinc-200">
            Composição Corporal
          </h3>
          <div className="flex flex-row items-center justify-center">
            <span className="text-zinc-500 dark:text-zinc-400">
              Sem dados para exibir.
            </span>
          </div>
        </div>
      );
    }

    const labels = ["Gordura", "Músculo", "Resíduos", "Ossos"];

    const renderLegend = (series: number[]) => {
      const total = series.reduce((acc, val) => acc + val, 0);
      const percentages = series.map((value) =>
        total ? ((value / total) * 100).toFixed(2) : "0.00",
      );
      return (
        <ul className="mt-4 w-full p-2 dark:bg-zinc-900">
          <div className="flex w-full flex-col items-start gap-2">
            {labels.map((label, index) => (
              <div
                key={label}
                className="flex w-full items-center space-x-2 rounded bg-black/5 p-1 text-sm text-zinc-700 dark:text-zinc-200"
              >
                <span className="flex items-center justify-center">
                  <div
                    className="h-4 w-4 rounded"
                    style={{ backgroundColor: colors[index] }}
                  />
                </span>
                <span className="flex-1">{label}:</span>
                <div className="flex w-16 flex-col items-end rounded bg-zinc-100 p-1 dark:bg-zinc-800">
                  <span className="text-xs font-semibold text-zinc-700 dark:text-zinc-200">
                    {`${percentages[index]} %`}
                  </span>
                  <span className="text-xs text-zinc-500 dark:text-zinc-400">
                    {`${series[index].toFixed(2)} kg`}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </ul>
      );
    };

    return (
      <div className="mb-8 flex flex-col">
        <h3 className="mb-4 text-lg font-semibold text-zinc-700 dark:text-zinc-200">
          Composição Corporal
        </h3>
        <div className="flex w-full flex-col md:flex-row">
          <div className="mb-4 flex w-full flex-row items-center justify-center bg-white p-4 dark:bg-zinc-800 md:mb-0 md:w-96 md:flex-col">
            <FaChartPie size={28} className="mb-2 text-zinc-800" />
            <p className="text-center text-xs font-semibold uppercase tracking-wide">
              Comparação Gráfica
            </p>
          </div>
          <div className="flex w-full flex-1 flex-col md:flex-row">
            {data.map((assessment) => {
              const graph = assessment.graph;
              if (!graph) return null;

              const series = [
                graph.fat ?? 0,
                graph.muscles ?? 0,
                graph.wastes ?? 0,
                graph.bones ?? 0,
              ];

              return (
                <div
                  key={assessment.id}
                  className="flex flex-1 flex-col items-center justify-center odd:bg-zinc-50 dark:bg-zinc-900 md:w-80"
                >
                  <div className="flex h-56 w-full items-center justify-center">
                    <Chart
                      options={{
                        chart: { type: "pie", background: "transparent" },
                        labels,
                        legend: { show: false },
                        colors,
                        tooltip: {
                          y: {
                            formatter: (val) => `${val.toFixed(2)} kg`,
                          },
                        },
                        responsive: [
                          {
                            breakpoint: 768,
                            options: {
                              chart: { width: "100%" },
                            },
                          },
                        ],
                      }}
                      series={series}
                      type="pie"
                      width="100%"
                      height="220"
                    />
                  </div>
                  <div className="w-full">{renderLegend(series)}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return renderGraphSection();
};

export default ComparisionGraph;
